import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    workUnitChannel = new Subject();
    EmployeeStatusChannel = new Subject();
    PresensiExportChannel = new Subject();
    PresensiKetidakhadiranExportChannel = new Subject();
    indexChannel = new Subject()
    employeeCategoriesChannel = new Subject()
    syncJabatanBknChannel = new Subject()

    repository = new IndexRepository()

    constructor() {
        this.workUnitChannel.next({status: apiResponse.INITIAL})
        this.EmployeeStatusChannel.next({status: apiResponse.INITIAL})
        this.PresensiExportChannel.next({status: apiResponse.INITIAL})
        this.PresensiKetidakhadiranExportChannel.next({status: apiResponse.INITIAL})
        this.indexChannel.next({status: apiResponse.INITIAL})
        this.employeeCategoriesChannel.next({status: apiResponse.INITIAL})
        this.syncJabatanBknChannel.next({status: apiResponse.INITIAL})
    }

    fetchWorkUnit = async (query) => {
        try {
            this.workUnitChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchWorkUnit(query).then((result) => {
                this.workUnitChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.workUnitChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchEmployeeStatus = async (query) => {
        try {
            this.EmployeeStatusChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEmployeeStatus(query).then((result) => {
                this.EmployeeStatusChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.EmployeeStatusChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchPresensiExport = async (query) => {
        try {
            this.PresensiExportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchPresensiExport(query).then((result) => {
                this.PresensiExportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.PresensiExportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchPresensiKetidakhadiranExport = async (query) => {
        try {
            this.PresensiKetidakhadiranExportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchPresensiKetidakhadiranExport(query).then((result) => {
                this.PresensiKetidakhadiranExportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.PresensiKetidakhadiranExportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchEmployeeCategories = async (query) => {
        try {
            this.employeeCategoriesChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEmployeeCategories(query).then((result) => {
                this.employeeCategoriesChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.employeeCategoriesChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchSyncJabatanBkn = async (query) => {
        try {
            this.syncJabatanBknChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchSyncJabatanBkn(query).then((result) => {
                this.syncJabatanBknChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.syncJabatanBknChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

}

export default IndexBloc